import type { ReimbursementNextStepsNoticeProps } from '../../types'

/** Matches Angular resident-edit-new default tab: inner *ngIf on reimbursement rental statuses. */
// eslint-disable-next-line react-refresh/only-export-components -- visibility predicate co-located with its callout
export function shouldShowReimbursementNextStepsNotice(rentalStatus: string | undefined): boolean {
  return !!rentalStatus && !['NOT_STARTED', 'ACTIVE', 'CLOSED'].includes(rentalStatus)
}


/**
 * “Please note” callout above Required Information on the Reimbursement tab.
 * Styling mirrors Angular `.next-steps` + `.numberlist` (custom.scss / resident-edit-new).
 */
export function ReimbursementNextStepsNotice({
  rentalList,
  rentalStatus,
  onOpenEorp,
  dataTestId = 'resident-reimbursement-next-steps-notice',
}: ReimbursementNextStepsNoticeProps) {
  const raw = rentalList?.rental_status?.[rentalStatus]?.next_step
  const entries = raw
    ? Object.entries(raw).sort(([a], [b]) => {
        const na = Number(a)
        const nb = Number(b)
        if (!Number.isNaN(na) && !Number.isNaN(nb) && na !== nb) return na - nb
        return String(a).localeCompare(String(b), undefined, { numeric: true })
      })
    : []

  return (
    <div
      className="next-steps mb-6 rounded bg-[#d1ecf1] px-3 py-4 text-left text-[13px] font-medium leading-relaxed text-[#1e7a8b] sm:px-5 sm:py-5"
      role="alert"
      data-testid={dataTestId}
    >
      <div className="mb-2 font-bold text-[#006064]">
        <strong>Please note:</strong>
      </div>
      {entries.length > 0 ? (
        <ul className="numberlist mb-3 list-decimal space-y-2 pl-6 marker:font-medium [&_em]:italic [&_i]:italic [&_strong]:font-semibold">
          {entries.map(([key, html]) => (
            <li key={key} dangerouslySetInnerHTML={{ __html: html }} />
          ))}
        </ul>
      ) : null}
      <button
        type="button"
        onClick={onOpenEorp}
        data-testid="resident-reimbursement-next-steps-eorp-button"
        className="block w-full text-left font-bold text-[#d12020] underline-offset-2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500 focus-visible:ring-offset-2"
      >
        Click here for the Explanation of the Reimbursement Process
      </button>
      <p className="mt-2 text-[13px] font-medium text-[#1e7a8b]">
        For additional questions, contact the Reimbursement Team via the Notes & Message Board.
      </p>
    </div>
  )
}
